import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './contexts/AuthContext';
import { AccessProvider } from './contexts/AccessContext';
import { assertRuntimeConfiguration } from './config/runtime';
import { prepareDirectContentHistory } from './utils/contentRoutes';
import { PublishingIdentityProvider } from './contexts/PublishingIdentityContext';
import { removeLegacyPageCaches } from './services/homeFeedStorage';
import { installPageCacheLifecycle } from './services/pageCache';

assertRuntimeConfiguration();
prepareDirectContentHistory();
// Migrate every device that loads this build, regardless of its initial route
// or login state. Cleanup runs in the background and keeps the new feed cache.
void removeLegacyPageCaches();
installPageCacheLifecycle();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <PublishingIdentityProvider>
      <AccessProvider>
        <App />
      </AccessProvider>
      </PublishingIdentityProvider>
    </AuthProvider>
  </React.StrictMode>
);

// Older builds registered the Firebase messaging worker at `/`, which allowed
// it to intercept the entire PWA and backend API. Remove that legacy
// registration before installing the normal application service worker. Push
// setup will recreate Firebase messaging under a narrow push-only scope.
const registerApplicationServiceWorker = async () => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(async (registration) => {
        const scriptUrls = [
          registration.active?.scriptURL,
          registration.waiting?.scriptURL,
          registration.installing?.scriptURL,
        ].filter(Boolean);
        const isRootMessagingWorker = (
          new URL(registration.scope).pathname === '/'
          && scriptUrls.some((url) => url.includes('/firebase-messaging-sw.js'))
        );
        if (isRootMessagingWorker) await registration.unregister();
      }));
    } catch (error) {
      console.warn('Unable to remove the legacy messaging service worker:', error);
    }
  }

  serviceWorker.register();
};

registerApplicationServiceWorker();

const setVh = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};
setVh();
window.addEventListener('resize', setVh);

// Prevent the browser's long-press/right-click menu on app content and media.
// Editable controls remain exempt so normal typing and clipboard actions work.
const isEditableTarget = (target) => (
  target instanceof Element &&
  Boolean(target.closest('input, textarea, [contenteditable="true"], [contenteditable="plaintext-only"]'))
);

document.addEventListener('contextmenu', (event) => {
  if (!isEditableTarget(event.target)) event.preventDefault();
}, { capture: true });

document.addEventListener('dragstart', (event) => {
  if (event.target instanceof Element && event.target.closest('img, video, audio, svg')) {
    event.preventDefault();
  }
}, { capture: true });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

